import {
    checkDomainConfigApi,
    deleteUserApi,
    fetchUsersApi,
    getProfileApi,
    getUserApi,
    loginUserApi,
    newUserApi,
    updateUserApi
} from "../../../common/api/userApi";
import {notificationSuccessMessage} from "../../../common/config/message";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {httpRequestFunc} from "../../../common/config/httpClient";
import {setModal, setRedirect} from "../utility";
import moment from "moment";
import {setDomainVerify, setTomanyLogin} from "./userSlice";
import {checkSubDomain} from "../../../common/api/gateway";

export const loginAsyncUser = createAsyncThunk(
    'users/loginAsyncUser',
    async ({username, password}, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, loginUserApi(username, password))
            baseThunk.dispatch(setRedirect(`/news`))
            return {
                accessToken: response?.data.access_token,
                refreshToken: response?.data.refresh_token
            }
        } catch (e) {
            if (typeof e?.payload !== `undefined` && e.payload === `TOO_MANY_LOGIN`) {
                baseThunk.dispatch(setTomanyLogin())
            }
        }
    }
)

export const fetchAsyncUsers = createAsyncThunk(
    'users/fetchAsyncUsers',
    async ({filter}, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, fetchUsersApi(filter))
            return response.data
        } catch (e) {
        }
    }
)

export const getAsyncProfile = createAsyncThunk(
    'users/getAsyncUsers',
    async (data, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, getProfileApi())
            //baseThunk.dispatch(getDomainAsyncConfig())
            return response.data
        } catch (e) {

        }

    }
)


export const getAsyncUser = createAsyncThunk(
    'users/getAsyncUser',
    async ({id}, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, getUserApi(id))
            return response.data
        } catch (e) {

        }

    }
)

export const newAsyncUser = createAsyncThunk(
    'users/newAsyncUser',
    async (data, baseThunk) => {

        // const response = httpRequestFunc(dispatch, newUserApi(data))

        try {
            // const response = await newUserApi(data)
            const response = await httpRequestFunc(baseThunk, newUserApi(data))
            if (response.status === 200) {
                notificationSuccessMessage(`บันทึกข้อมูลสำเร็จ`)
                const user = response.data

                // baseThunk.dispatch(fetchAsyncUsers({
                //     filter: {
                //         page: 1,
                //         pageSize: 15,
                //     }
                // }))

                baseThunk.dispatch(setModal(false))
                // baseThunk.dispatch(setRedirect(`/user?t=${moment().unix()}`))
                return user
            }
        } catch (e) {
            // notificationErrorMessage(e)
        }
    }
)

export const updateAsyncUser = createAsyncThunk(
    'users/updateAsyncUser',
    async ({id, data}, baseThunk) => {
        try {
            // console.log(data)
            // const response = await updateUserApi(data.username, data)
            const response = await httpRequestFunc(baseThunk, updateUserApi(id, data))
            if (response.status === 200) {
                baseThunk.dispatch(setModal(false))
                notificationSuccessMessage(`บันทึกข้อมูลสำเร็จ`)
                // baseThunk.dispatch(fetchAsyncUsers({
                //     filter: {
                //         page: 1,
                //         pageSize: 15,
                //     }
                // }))
                const user = response.data
                return user
            }
        } catch (e) {
            // notificationErrorMessage(e)
        }
    }
)


export const deleteAsyncUser = createAsyncThunk(
    'users/deleteAsyncUser',
    async ({id}, baseThunk) => {
        try {
            // const response = await deleteUserApi(id)
            const response = await httpRequestFunc(baseThunk, deleteUserApi(id))
            if (response.status === 200) {
                notificationSuccessMessage(`ทำรายการสำเร็จ`)
                // baseThunk.dispatch(fetchAsyncUsers({
                //     filter: {
                //         page: 1,
                //         pageSize: 15,
                //     }
                // }))
                return id
            }
        } catch (e) {
            // notificationErrorMessage(e)
        }
    }
)
export const getDomainAsyncConfig = createAsyncThunk(
    'users/getDomainAsyncConfig',
    async (data, baseThunk) => {
        try {
            const domain = checkSubDomain()
            // if (typeof domain === `undefined` || domain === `test` || domain === `` || domain === `localhost:3000`) {
            //     domain = `main`
            // }
            const response = await httpRequestFunc(baseThunk, checkDomainConfigApi(domain))
            if (response.status === 200) {
                baseThunk.dispatch(setDomainVerify(1))
                return response.data
            }
        } catch (e) {
            baseThunk.dispatch(setDomainVerify(2))
        }
    }
)
